class DlPageBannerWithCtaM extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.discountCopyBtn = this.querySelector('.dl-page-banner-with-cta-m__coupon-copy-btn');
    this.discountCode = this.discountCopyBtn?.dataset?.discountCode;

    this.primaryCta = this.querySelector('[data-cta-role="primary"]');
    this.secondaryCta = this.querySelector('[data-cta-role="secondary"]');
    this.videoMount = this.querySelector('[data-banner-video-mount]');
    this.mobileMediaQuery = window.matchMedia('(max-width: 989px)');
    this.bindEvents();
    this.initBannerVideo();
  }

  bindEvents() {
    if (this.discountCopyBtn && this.discountCode) {
      this.discountCopyBtn.addEventListener('click', this.handleCopyCoupon.bind(this));
    }

    if (this.primaryCta) {
      this.primaryCta.addEventListener('click', () => {
        this.trackCtaClick(this.primaryCta, 'banner_cta_primary_btn_click');
      });
    }

    if (this.secondaryCta) {
      this.secondaryCta.addEventListener('click', () => {
        this.trackCtaClick(this.secondaryCta, 'banner_cta_secondary_btn_click');
      });
    }

    this.querySelector('.dl-page-banner-with-cta-m__scroll')?.addEventListener('click', (event) => {
      const target = document.getElementById(event.currentTarget.getAttribute('href').slice(1));
      if (!target) return;

      event.preventDefault();
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      const mobileHeader = window.matchMedia('(max-width: 990px)').matches
        ? document.querySelector('sticky-header')?.closest('.section-header')
        : null;

      if (mobileHeader) {
        // Reserve the full header height even if it is currently hidden while scrolling.
        window.scrollTo({
          top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - mobileHeader.offsetHeight),
          behavior,
        });
        return;
      }

      target.scrollIntoView({
        behavior,
        block: 'start',
      });
    });

    this.mobileMediaQuery.addEventListener('change', this.handleViewportChange);
  }

  disconnectedCallback() {
    this.mobileMediaQuery?.removeEventListener('change', this.handleViewportChange);
  }

  handleViewportChange = () => {
    this.mountActiveVideo();
  };

  initBannerVideo() {
    if (!this.videoMount) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveDataEnabled = navigator.connection?.saveData;

    // Keep the lightweight poster for visitors who explicitly prefer less motion/data.
    if (prefersReducedMotion || saveDataEnabled) return;

    this.mountActiveVideo();
  }

  mountActiveVideo() {
    const device = this.mobileMediaQuery.matches ? 'mobile' : 'desktop';
    if (this.activeVideoDevice === device) return;

    const template = this.querySelector(`[data-banner-video-template="${device}"]`);
    if (!template) return;

    this.videoMount.replaceChildren(template.content.cloneNode(true));
    this.activeVideoDevice = device;

    const video = this.videoMount.querySelector('video');
    video?.play().catch(() => {
      // Autoplay may be blocked by browser policy; the poster remains visible.
    });
  }

  trackCtaClick(btn, eventName) {
    if (typeof DLPixelH?.capture !== 'function') return;
    DLPixelH.capture(eventName, {
      btn_text: (btn.textContent || '').trim(),
    });
  }

    handleCopyCoupon() {
        navigator.clipboard.writeText(this.discountCode);
        this.showCopied();
        setTimeout(() => {
            this.hideCopied();
        }, 1000);
    }

    showCopied() {
        this.discountCopyBtn.classList.add('dl-copied');
    }

    hideCopied() {
        this.discountCopyBtn.classList.remove('dl-copied');
    }
}
customElements.define('dl-page-banner-with-cta-m', DlPageBannerWithCtaM);